import React from "react"

const ProductsEN = () => <>
  <h2>Products</h2>
  <p className="bigger-text text-center"> Currently, our team is developing a new generation and environmentally
    friendly paints for the automotive, railway, marine, aviation, and metal industry.</p><br /><br /><br /><br /><br /><br />
</>

export default ProductsEN